import React from "react";
import { Box, List, Typography } from "@mui/material";
import moment from "moment";

const HistoryTab = ({ fieldHist }) => {
  return (
    <List
      sx={{
        width: "100%",
        bgcolor: "background.paper",
        height: "calc(100vh - 300px)",
        overflow: "auto",
      }}
    >
      {fieldHist && fieldHist.length > 0 ? (
        fieldHist.map(
          (_valObj, index) =>
            fieldHist[index - 1]?.value !== _valObj.value && (
              <Box key={`val${index}`} sx={{ paddingY: 1 }}>
                <Typography>
                  {
                    <>
                      <span style={{ fontWeight: 600 }}>{_valObj.user}</span>
                      <span> updated the value </span>
                      <span style={{ fontWeight: 600 }}>{_valObj.value}</span>
                    </>
                  }
                </Typography>
                <Typography style={{ color: "grey", fontWeight: 400 }}>
                  {" "}
                  {_valObj.date}
                </Typography>
              </Box>
            )
        )
      ) : (
        <Typography sx={{ color: "grey", paddingY: 2 }}>
          No history exist
        </Typography>
      )}
    </List>
  );
};

export default React.memo(HistoryTab);

